import { IoClose } from "react-icons/io5";
import { restaurantDetails } from "../../../data/restaurantStatusData";

interface SuspendedRestaurantModalProps {
  toggleModal: () => void;
  restaurantId: string;
}

const SuspendedRestaurantModal = ({ toggleModal, restaurantId }: SuspendedRestaurantModalProps) => {
  const restaurant = restaurantDetails[restaurantId as keyof typeof restaurantDetails];

  if (!restaurant || (restaurant as any).type !== "suspended") return null;
  
  const suspendedRestaurant = restaurant as any;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <div className="flex justify-between items-start mb-4">
          <div>
            <h2 className="text-xl font-bold text-secondary">{suspendedRestaurant.name}</h2>
            <p className="text-gray-500 text-sm">Restaurant details and documentation</p>
          </div>
          <button
            onClick={toggleModal}
            className="text-gray-400 hover:text-gray-600"
          >
            <IoClose className="w-6 h-6" />
          </button>
        </div>

        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <p className="font-semibold text-sm">Phone Number:</p>
              <p className="text-gray-600 text-sm">{suspendedRestaurant.phone}</p>
            </div>
            <div>
              <p className="font-semibold text-sm">E-mail Address:</p>
              <p className="text-gray-600 text-sm">{suspendedRestaurant.email}</p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <p className="font-semibold text-sm">Location:</p>
              <p className="text-gray-600 text-sm">{suspendedRestaurant.location}</p>
            </div>
            <div>
              <p className="font-semibold text-sm">Status:</p>
              <p className="text-red-500 text-sm">{suspendedRestaurant.status}</p>
            </div>
          </div>

          {suspendedRestaurant.accountSuspended && (
            <div className="bg-red-50 p-4 rounded-md">
              <p className="font-semibold text-red-600 text-sm">Account Suspended</p>
              <p className="text-sm mt-1"><span className="font-medium">Date:</span> {suspendedRestaurant.accountSuspended.date}</p>
              <p className="text-sm mt-1"><span className="font-medium">Reason:</span> {suspendedRestaurant.accountSuspended.reason}</p>
              <p className="text-sm mt-1">
                <span className="font-medium">Wallet Balance:</span> ₦{suspendedRestaurant.accountSuspended.walletBalance.toLocaleString()} {suspendedRestaurant.accountSuspended.payoutNote}
              </p>
            </div>
          )}

          {suspendedRestaurant.stats && (
            <div className="grid grid-cols-3 gap-4 mt-4">
              <div className="text-center">
                <p className="font-semibold text-sm">Rate:</p>
                <p className="text-sm">{suspendedRestaurant.stats.rate}</p>
              </div>
              <div className="text-center">
                <p className="font-semibold text-sm">Total Order:</p>
                <p className="text-sm">{suspendedRestaurant.stats.totalOrder}</p>
              </div>
              <div className="text-center">
                <p className="font-semibold text-sm">Revenue:</p>
                <p className="text-sm">{suspendedRestaurant.stats.revenue}</p>
              </div>
            </div>
          )}

          <div className="flex gap-3 mt-6">
            <button className="flex-1 bg-secondary text-white py-2 px-4 rounded-md hover:bg-secondary-dark transition-colors">
              Reactivate
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuspendedRestaurantModal;